<template>

    <ui-modal
        class="parcel-prediction-modal"
        title="Voorspellingen"
        :padding="false"
        @close="cancel">

        <ui-view-panel>

            <template v-if="forecast">

                <div class="parcel-prediction-wrapper">

                    <div class="parcel-prediction">
                        <span class="title">3 maanden:</span>
                        <ul class="list">
                            <li class="list-item">Verwachte groei: {{ forecast['three_months']['expected_growth'] }} gram</li>
                            <li class="list-item">Foutenmarge: {{ forecast['three_months']['error_margin'] }} gram</li>
                        </ul>
                    </div>

                    <div class="parcel-prediction">
                        <span class="title">6 maanden:</span>
                        <ul class="list">
                            <li class="list-item">Verwachte groei: {{ forecast['six_months']['expected_growth'] }} gram</li>
                            <li class="list-item">Foutenmarge: {{ forecast['six_months']['error_margin'] }} gram</li>
                        </ul>
                    </div>

                    <div class="parcel-prediction">
                        <span class="title">1 jaar:</span>
                        <ul class="list">
                            <li class="list-item">Verwachte groei: {{ forecast['one_year']['expected_growth'] }} gram</li>
                            <li class="list-item">Foutenmarge: {{ forecast['one_year']['error_margin'] }} gram</li>
                        </ul>
                    </div>

                </div>

            </template>

        </ui-view-panel>

    </ui-modal>

</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';

import dismissalMixin from 'js-core/js/mixins/dismissal';

@Component({

    name: 'ParcelPredictionModal',
    mixins: [dismissalMixin],
    props: ['forecast']
})
export default class ParcelPredictionModal extends Vue {

}

</script>